<template>
    <div id="page-tools-query">
        <vx-card ref="filterCard" class="mb-1">
            <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="w-full" placeholder="Ip" v-model="ip"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="w-full" placeholder="Member name" v-model="members"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="w-full" placeholder="Match" v-model="match"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="w-full" placeholder="Choice" v-model="choice"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-input class="w-full" placeholder="Handicap" v-model="handicap"/>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6" >
                    <vs-select v-model="board_selected">
                        <vs-select-item value="0" text="ibet & sbo"/>
                        <vs-select-item value="1" text="ibet"/>
                        <vs-select-item value="2" text="sbo"/>
                    </vs-select>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
                    <date-range-picker 
                        @date-change="onDateFilterChange" 
                        :initDate="{from: fromDate, to: toDate}"
                        actionBtnText="Xem"
                        :actionBtn="onDateRangeAction"
                    />
                </vs-col>
            </vs-row>
        </vx-card>

        <div class="vx-card">
            <vs-table 
                :data="dataView"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
                description
                description-title="Query"
                description-connector="of"
            >
                <template slot="header">
                    <!-- ITEMS PER PAGE -->
                    <div class="">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <span :class="winloss > 0 ? 'pr-4 win' : 'pr-4 loss'">Winloss: {{winloss}}</span>
                    <span>Total Bet: {{totalBet}}</span>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                    <vs-th v-if="!$route.query.ip && !$route.query.members && !$route.query.match && !$route.query.choice && !$route.query.handicap" />
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                            <template v-if="h.render">
                                {{ h.render(data[indextr]) }}
                            </template>
                            <template v-else>
                                {{ data[indextr][h.field] }}
                            </template>
                        </vs-td>
                        <vs-td v-if="!$route.query.ip && !$route.query.members && !$route.query.match && !$route.query.choice && !$route.query.handicap">
                            <vs-button size="small" type="flat" color="primary" class="vs-button--link" @click="moreAction(data[indextr])">...</vs-button>
                            <vs-button size="small" type="flat" color="primary" class="vs-button--link" @click="moreActionSG(data[indextr])">SG</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import { AclRule } from 'vue-acl';
import numeral from 'numeral';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data(){
        return {
            itemsPerPage: 100,
            header: [
                { title:"Member", field:"member_name", render: function(data){ return data.member_name.toUpperCase(); } },
                { title:"Ngày", field:"bet_time", render: function(data){ return moment(data.bet_time).format("DD-MM-YYYY_HH:mm:ss") } },
                { title:"IP", field:"bet_ip" },
                { title:"Sàn", field:"board_id", render: function(data){ return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbo" : "unknown"; }},
                { title:"Chọn", field:"bet_choice", render: function(data){ return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
                { title:"Trận", field:"bet_match" },
                { title:"Loại", field:"bet_type" }, 
                { title:"Odds", field:"bet_odds" },
                { title:"Stake", field:"bet_stake" },
                { title:"Status", field:"bet_status" },
                { title:"VN Time", field:"bet_time", render: function(data){ return moment(data.bet_time).add(11, 'hours').format("HH:mm:ss") } }
            ],
            dataAll: [],
            dataView: [],
            fromDate: this.$route.query.from || moment().format("YYYY-MM-DD"),
            toDate: this.$route.query.to || moment().format("YYYY-MM-DD"),
            ip: this.$route.query.ip || "",
            members: this.$route.query.members || "",
            match: this.$route.query.match || "",
            choice: this.$route.query.choice || "",
            handicap: this.$route.query.handicap || "",
            winloss: 0,
            totalBet:0,
            board_selected: 0
        }
    },
    components: {
        vSelect,
        DateRangePicker
    },
    // beforeRouteUpdate (to, from, next) {
    //     this.date = to.query.date;
    //     this.fetchCheatIP(to.query.date);
       
    //     next();
    // },
    watch:{
        board_selected(newVal){
            let vm = this;

            if(newVal == 0){
                vm.dataView = vm.dataAll;
            }else{
                let tmp = [];  
                vm.dataAll.forEach(function(bet, index){
                    if(bet.board_id == newVal){
                        tmp.push(bet);
                    }
                });

                vm.dataView = tmp;
            }
        }
    },
    computed: {
        fetchQueryDataPermission(){
            return new AclRule('store_bet_query').generate();
        },
    },
    methods:{
        fetchQuery() {
            if(this.$acl.not.check('fetchQueryDataPermission')) return;

            let vm = this;
            let payload = {
                "ip": this.ip,
                "member_name": this.members,
                "match": this.match,
                "choice": this.choice,
                "handicap": this.handicap,
                "from": this.fromDate,
                "to": this.toDate
            };

            this.$http.post('bets/query', payload).then((res) => {
                if(res.data.code < 0){
                    Swal.fire("", res.data.msg, "error");
                    return;
                }
                vm.dataAll = res.data.data.data;
                vm.winloss = res.data.data.winloss;
                vm.totalBet = res.data.data.data.length;

                if(vm.board_selected == 0){
                    vm.dataView = res.data.data.data;
                }else{
                    let tmp = [];  
                    res.data.data.data.forEach(function(bet, index){
                        if(bet.board_id == vm.board_selected){
                            tmp.push(bet);
                        }
                    });

                    vm.dataView = tmp;
                }
            });
        },
        onDateFilterChange(data){
            this.fromDate = data.fromDate;
            this.toDate = data.toDate;

            if(this.ip == "" && this.members == "" && this.match == "" && this.choice == "" && this.handicap == ""){
                Swal.fire("", "Vui lòng nhập thông tin để tìm kiếm!", "error");
                return;
            }

            this.fetchQuery();
        },
        onDateRangeAction(){
            if(this.ip == "" && this.members == "" && this.match == "" && this.choice == "" && this.handicap == ""){
                Swal.fire("", "Vui lòng nhập thông tin để tìm kiếm!", "error");
                return;
            }

            this.fetchQuery();
        },
        moreAction(data){
            let routeData = this.$router.resolve({
                name: 'query', 
                query: {
                    match: data.bet_match, 
                    choice: data.bet_choice, 
                    handicap: data.bet_handicap,
                    from: this.fromDate,
                    to: this.toDate
                }
            });

            window.open(routeData.href, '_blank');
        },
        moreActionSG(data){
            let routeData = this.$router.resolve({
                name: 'query_sap_gia', 
                query: {
                    bet_id: data.id, 
                    member_name: data.member_name, 
                    match: data.bet_match, 
                    choice: data.bet_choice, 
                    from: this.fromDate,
                    to: this.toDate
                }
            });

            window.open(routeData.href, '_blank');
        }
    },
    created(){
        if(this.$route.query.from && this.$route.query.to && this.$route.query.match && this.$route.query.choice && this.$route.query.handicap){
            this.onDateRangeAction();
        }
    }
};
</script>

<style>

#page-tools-query{
    margin-right: -30px !important;
}

#page-tools-query .container{
    margin: 0;
}
#page-tools-query .row2{
    padding-top: 10px;
}
#page-tools-query .swal2-container{
    z-index: 99999;
}
#page-tools-query .vs-button--link{
    padding: 0px !important;
}
#page-tools-query .loss{
    color: red;
}
#page-tools-query .win{
    color: #03f;
}
</style>
